import React, { Component }  from 'react'
import { connect } from 'react-redux'
import CommonTable from 'components/Table'

import { Column } from 'react-virtualized'
import Badge from 'components/Badge'
import TransactionStatusIcon from './StatusIcon'
// import {transactionsTable} from 'selectors/transactionsTable'
import {currentFilter} from 'selectors/filters'
import Numeral from 'numeral'
import {getMonth} from 'utils/date'
import calcTable from 'utils/calcTable'
import { getTimezoneDate } from 'utils/date'
import { transactionsTable } from 'selectors/transactionsTable'

let select = (state) => ({
	transactionsEx: transactionsTable(state)
  , currentFilter: currentFilter('transaction')(state)
})

export class TransactionTable extends Component{
	render(){
		let { props } = this
		let cols = {
			type:35
		  , amount: 150
		  , property:{min:200, avg:400}
		  , dueDate: 120
		  , party:{min:300, avg: 600}
		  , paymentMethod:160
		  , description:{min:250, avg: 500}
		  , attachComment:70
		}
	   if (~props.currentFilter.indexOf("Invoices")) cols.paymentMethod = false
		cols = calcTable(props.width, cols)
		return(
			<CommonTable entity="transaction" data={props.transactionsEx}>
				<Column
					 width={cols.type}
					 label="type"
					 dataKey="type"
					 cellRenderer={
						({ rowData }) => (<TransactionStatusIcon transactionID={rowData._id} />)
					 }
				/>
				<Column
					 width={cols.property}
					 label="property"
					 dataKey='property'
				/>
				{cols.party &&
					<Column
						 width={cols.party}
						 label="party"
						 dataKey='party'
					/>
				}
				{cols.description &&
					<Column
						 width={cols.description}
						 label="description"
						 dataKey='description'
					/>
				}
				{cols.paymentMethod &&
					<Column
						 width={cols.paymentMethod}
						 label="Method"
						 dataKey='paymentMethod'
					/>
				}
				<Column
					 width={cols.amount}
					 headerRenderer={()=><div style={{textAlign:"right", width:"100%", height:"19px"}}>Amount</div>}
					 style={{textAlign:"right"}}
					 dataKey="amount"
					 cellRenderer={
						({ rowData }) => (
							<div style={{color: (rowData.type && rowData.type.indexOf('invoice')==-1)?"#FF0000":"green"}}>
									{(rowData.type && rowData.type.indexOf('invoice')==-1 && rowData.amount)?'-':''}
									{rowData.type && rowData.type.indexOf('invoice')!=-1 ?
										<span style={{fontSize: "14px", fontWeight: "bold", textDecoration: (rowData.balance>=0)?"line-through":"none"}}>
											${rowData.balance>=0?Numeral(Math.abs(rowData.amount)).format('0,00.')
												:(+rowData.balance <= +rowData.amount)?Numeral(Math.abs(rowData.amount)).format('0,00.')
												:`${Numeral(Math.abs(rowData.amount)).format('0,00.')}
												-${Numeral(Math.abs(rowData.balance)).format('0,00.')}
												=${Numeral(Math.abs(rowData.amount+(-rowData.balance || 0))).format('0,00.')}`}
										</span>
									:<span style={{fontSize: "14px", fontWeight: "bold", textDecoration: (rowData.balance<=0 && rowData.paymentsAmount!=0)?"line-through":"none"}}>
										${Numeral(Math.abs(rowData.amount)).format('0,00.')}
									</span>}
							</div>
						)
					 }
				/>
				{cols.dueDate &&
					<Column
						 width={cols.dueDate}
						 label={<span style={{marginLeft:"0px"}}>Due date</span>}
						 headerRenderer={()=><div style={{textAlign:"right", width:"100%", height:"19px"}}>Due date</div>}
						 dataKey="dueDate"
						 style={{textAlign:"right"}}
						 cellRenderer={
							({ rowData }) => (
								(rowData.dueDate)?
								<div style={{textAlign:"right", color:((rowData.balance>0) && (new Date().valueOf() - new Date (rowData.dueDate).valueOf())>0)?"red":""}}>
									{`${getTimezoneDate(rowData.dueDate).getDate()} ${getMonth(getTimezoneDate(rowData.dueDate).getMonth())} ${getTimezoneDate(rowData.dueDate).getFullYear()}`}
								</div>:''
							)
						 }
					/>
				}
				{/*widthCategory>1 &&<Column
					 width={15}
					 disableSort
				/>*/}
				{cols.attachComment &&
					<Column
					 width={cols.attachComment/2}
					 label={<i style={{fontSize:"22px"}} className="material-icons">attach_file</i>}
					 dataKey='attachments'
					 disableSort
					 cellRenderer={({ rowData }) =>
						 <Badge
							 style={{position:"relative", top:"8px", left:"-8px"}}
							 badgeContent={rowData.attachments ? rowData.attachments.length : "0"}
							 primary={false}
							 secondary={rowData.attachments ? !!rowData.attachments.length : false}
						 />
					 }
					 />
				}
				{cols.attachComment &&
				  <Column
					width={cols.attachComment/2}
					label={<i style={{fontSize:"22px"}} className="material-icons">comment</i>}
					dataKey='comments'
					disableSort
					cellRenderer={({ rowData }) =>
						<Badge
							style={{position:"relative", top:"8px", left:"-8px"}}
							badgeContent={rowData.comments.length}
							primary={false}
							secondary={!!rowData.comments.length}
						/>
					}
				  />
				}
			</CommonTable>
		)
	}
}
export default connect(select)(TransactionTable)



// WEBPACK FOOTER //
// ./src/routes/manager/transactions/Table.js